/**
 * @file src/components/icons/elevenlabs.tsx
 */
import { IconProps } from 'types';

const ElevenLabs = ({ title = 'ElevenLabs', className }: IconProps) => (
    <svg
        className={className}
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
    >
        <title>{title}</title>
        <rect
            x="8"
            y="4"
            width="2"
            height="16"
            rx="1"
            fill="currentColor"
        />
        <rect
            x="14"
            y="4"
            width="2"
            height="16"
            rx="1"
            fill="currentColor"
        />
    </svg>
);

export default ElevenLabs;
